var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrequalStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16343_6339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.24984 1.5L9.05234 5.15167L13.0832 5.74083L10.1665 8.58167L10.8548 12.595L7.24984 10.6992L3.64484 12.595L4.33317 8.58167L1.4165 5.74083L5.44734 5.15167L7.24984 1.5Z",
    fill: "#EFC10D",
    stroke: "#EFC10D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16343_6339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.25 0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrequalStar);
export default __webpack_public_path__ + "static/media/prequal_star.6423d1d5.svg";
export { ForwardRef as ReactComponent };